<template>
  <div id="administration">
    <el-card class="noticeContent">
      <div slot="header" class="clearfix">
        <el-row :gutter="20">
          <el-col :span="4">
            <SearchWidget
              :placeholder="searchPlaceholder"
              @bySearchVal="getSearchVal"
              :width='"200px"'
            ></SearchWidget>
          </el-col>
          <el-col :span="6">
            <SelectDepartment @byDepartmentId="getDepartmentId"></SelectDepartment>
          </el-col>
          <el-col :span="4">
            <SelectTags @byTags="getTags"></SelectTags>
          </el-col>
          <el-col :span="8">
            <DatePicker
              type="daterange"
              size="large"
              format="yyyy-MM-dd"
              placeholder="请选择发送时间范围"
              style="width: 350px"
              v-model="timeRange"
              transfer
            ></DatePicker>
          </el-col>
          <el-col :span="2">
            <el-button type="text" @click="gotoDetailPage('add',0)">发布通知</el-button>
          </el-col>
        </el-row>
      </div>
      <Table :columns="tableColumns" :data="tableData">
        <template slot-scope="{ row, index }" slot="tags">
          {{getTagString(row.tags)}}
        </template>
        <template slot-scope="{ row, index }" slot="noticeRange">
          <p>
            <strong>{{ filterName(row.departmentsRange,'departmentName','部门：') }}</strong>
          </p>
          <p>
            <strong>{{ filterName(row.employeesRange,'employeeName','人员：') }}</strong>
          </p>
        </template>
        <template slot-scope="{ row, index }" slot="readCondition">
          <strong>{{ row.noticeEmployeeCount.noticeCount + '人(' + row.noticeEmployeeCount.readCount + '人已读)'}}</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="gotoDetailPage('watch',row.id)"
          >查看</Button>
          <Button
            type="success"
            size="small"
            @click="gotoDetailPage('edit',row.id)"
            v-if="!row.published"
          >编辑</Button>
          <Button type="error" size="small" @click="deletedNotice(row.id)" v-if="!row.published">删除</Button>
        </template>
      </Table>
      <Pagination :dataCount="total" @byPageSize="getPageSize" @byPageCurrent="getPageCurrent"></Pagination>
    </el-card>
  </div>
</template>

<script>
const initNotice = {
  title: "",
  sendTime: "",
  departments: [],
  employees: [],
  content: "",
  issuer: "",
  tags: [],
  noticeEmployeeCount: {
    noticeCount: "",
    readedCount: ""
  }
};
import SearchWidget from "@/components/search/tableSearch.vue";
import SelectDepartment from "@/components/business/selectDepartment/selectDepartmentByDropdown.vue";
import SelectTags from "@/components/business/selectTags/selectTagsByDropdown.vue";
import Pagination from "@/components/page/pagination.vue";
export default {
  components: {
    SearchWidget,
    SelectDepartment,
    SelectTags,
    Pagination
  },
  computed: {
    submitData() {
      var config = {
        conditions: [],
        size: this.pageSize,
        from: this.pageCurrent
      };
      if (this.searchVal) {
        config.conditions.push({ field: "title", value: this.searchVal });
      }
      if (this.departmentId) {
        config.conditions.push({ field: "departmentId", value: this.departmentId });
      }
      if (this.tag) {
        config.conditions.push({ field: "tagId", value: this.tag });
      }
      if (this.timeRange[0]) {
        var startTime = this.$js.dateTimeUtils(this.timeRange[0]).date;
        config.conditions.push({ field: "startTime", value: startTime });
      }
      if (this.timeRange[1]) {
        var endTime = this.$js.dateTimeUtils(this.timeRange[1]).date;
        config.conditions.push({ field: "endTime", value: endTime });
      }
      return config;
    }
  },
  watch: {
    submitData: {
      handler(val) {
        this.getNotice(val);
      },
      immediate: true
    },
  },
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageCurrent: 1,
      tag: "",
      searchVal: "",
      departmentId: "",
      timeRange: ["", ""],
      searchPlaceholder: "输入标题搜索",
      tableColumns: [
        {
          title: "通知标题",
          key: "title",
          align: "center",
          minWidth: 150
        },
        {
          title: "发送时间",
          key: "sendTime",
          align: "center",
          minWidth: 150
        },
        {
          title: "发布人",
          key: "senderName",
          align: "center",
          minWidth: 150
        },
        {
          title: "标签",
          slot: "tags",
          align: "center",
          minWidth: 200
        },
        {
          title: "通知范围",
          slot: "noticeRange",
          align: "center",
          minWidth: 200
        },
        {
          title: "已读情况",
          slot: "readCondition",
          align: "center",
          minWidth: 200
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center"
        }
      ],

      tableData: []
    };
  },
  methods: {
    getTagString(tagsList){
      if(!tagsList || !tagsList.length){
        return ''
      }
      return tagsList.map((item) => {
        return item.tagName
      }).join('，')
    },
    getNotice(val) {
      this.$api.getNoticeList(val).then(res => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    getTags(val) {
      this.tag = val;
    },
    getSearchVal(val) {
      this.searchVal = val;
    },
    getDepartmentId(val) {
      this.departmentId = val;
    },
    gotoDetailPage(type, id) {
      this.$router.push({
        path: "/notification/publishNotice",
        query: { id: id, type: type }
      });
    },
    deletedNotice(id) {
      this.$api.deleteNotice({ id: id }).then(() => {
        this.$Message.success("删除成功！");
        this.getNotice(this.submitData);
      });
    },
    //分页信息
    getPageSize(val) {
      this.pageSize = val;
    },
    getPageCurrent(val) {
      this.pageCurrent = val;
    },
    filterName(arr, attr, name) {
      if (!arr || !arr.length) {
        return "";
      }
      return ( name + arr.map( arr => {
          return arr[attr];
        }).join("，")
      );
    }
  }
};
</script>

<style scoped>
.noticeContent {
  margin: 20px;
}
</style>

<style>
.ivu-input-large {
  height: 40px;
}
</style>

